import { UPDATE_DRAFT } from 'ducks/drafts2/constants'
import { doSendDraftToServer } from './doSendDraftToServer'

export function doReinstateDraft(draft) {
  return dispatch => {
    dispatch({
      type: UPDATE_DRAFT,
      data: {
        draftType: draft.draftType,
        draftId: draft.id,
        ticketId: draft.ticketId,
        fields: draft,
      },
    })
    dispatch(doSendDraftToServer(draft.id, draft.ticketId))
  }
}
